export default [
  {
    name: 'setting-tasks',
    path: '/settings/tasks',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Tarefas',
      icon: 'dvr',
      label: 'Configurações gerais',
      roles: ['Admin']
    }
  },
  {
    name: 'task-tags-details',
    path: '/settings/tasks/tags/:id',
    component: () => import(/* webpackChunkName: "event" */ './tags/Detail.vue'),
    meta: {
      showNavbar: false,
      title: 'Tarefas - Detalhes da tarefa',
      icon: 'dvr',
      label: 'Tarefas - Detalhes da tarefa',
      roles: ['Admin']
    }
  },
  {
    name: 'task-change-status-details',
    path: '/settings/tasks/change-status/:id',
    component: () => import(/* webpackChunkName: "event" */ './change-status/Detail.vue'),
    meta: {
      showNavbar: false,
      title: 'Tarefas - Detalhes da mudança de status',
      icon: 'dvr',
      label: 'Tarefas - Detalhes da mudança de status',
      roles: ['Admin']
    }
  },
  {
    name: 'task-flight-block-details',
    path: '/settings/tasks/flight-block/:id',
    component: () => import(/* webpackChunkName: "event" */ './flight-block/Detail.vue'),
    meta: {
      showNavbar: false,
      title: 'Tarefas - Detalhes do Bloqueio Aéreo',
      icon: 'dvr',
      label: 'Tarefas - Detalhes do Bloqueio Aéreo',
      roles: ['Admin']
    }
  }
]
